import { Box, Grid, useMediaQuery, useTheme } from '@mui/material'
import { FooterIcon } from 'src/utils/Icon'
import { IFooter } from '.'
import { DownloadIcon, ExplanationImg } from './style'

const DefaultImage = ({ isAuthScreen }: IFooter) => {
  const theme = useTheme()
  const isSMDown = useMediaQuery(theme.breakpoints.down('sm'))
  const explanationImgURL = isSMDown ? FooterIcon.MobileExplanation : FooterIcon.PCExplanation

  return (
    <>
      <ExplanationImg src={explanationImgURL} alt="電力クーポンアプリ登場" />

      {isSMDown && (
        <Box mb={isAuthScreen ? 15 : 0}>
          <Grid container direction="row" justifyContent="space-between" wrap="nowrap">
            <Grid item>
              <DownloadIcon alt="app store" src={FooterIcon.AppStore} />
            </Grid>

            <Grid item>
              <DownloadIcon alt="google play" src={FooterIcon.GooglePlay} />
            </Grid>
          </Grid>
        </Box>
      )}
    </>
  )
}

export default DefaultImage
